import Button from "../Button";
import {useContext, useEffect, useState} from "react";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import BottomButtonWrapper from "../BottomButtonWrapper";
import LoadingScreen from "../LoadingScreen";
import Api from "../../tools/service";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/Authentication";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import SuccessStageModal from "../modals/SuccessStageModal";
import ConfirmDeleteWidgetModal from "../modals/ConfirmDeleteWidgetModal";
import {AiFillEdit} from "react-icons/ai";
import EditAuthWidgetModal from "../modals/EditAuthWidgetModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import DeleteAuthenticationModal from "../modals/DeleteAuthenticationModal";
import useDivarAuth from "../../hooks/useDivarAuth";


const Widget = ({widget,handleInquiryProcess}) => {
    const {postToken}=useDivarAuth();
    const [widgetBody, setwidgetBody] = useState({...widget})
    const [isLoading, setLoading] = useState(false);
    const serviceContext = useContext(AuthenticationServiceContext);
    const handleDeleteWidget = (serviceType) => {
        Reoverlay.hideModal();
        Reoverlay.showModal(ConfirmDeleteWidgetModal, {
            title: 'آیا مطمئن هستید؟',
            description: 'افزونه شما از روی آگهی حذف خواهد شد.',
            confirmButtonText: 'حذف افزونه',
            onDelete: () => {
                setLoading(true);
                Api.delete(REQUEST_URLS.AUTHENTICATION.DELETE_WIDGET, {
                    params:{
                        pid:widgetBody.pid,
                        delete_type:serviceType ? "piece_widget" : "full_widget",
                        post_token:postToken,
                        piece_name:serviceType || null
                    },
                    headers: {
                        "Authorization": `Bearer ${serviceContext.token}`
                    }
                }).then(response => {
                    const {data, message, status, hasError} = response;
                    if (hasError) {
                        serviceContext.handleError({
                            status,
                            data,
                            message,

                            callback: () => {
                                Reoverlay.showModal(ErrorModal, {
                                    title: 'خطا',
                                    message: message || 'خطای سرویس',
                                    showConfirmButton: false,
                                    showCancelButton: true,
                                    cancelButtonText: 'بستن',
                                    cancelButtonTheme: 'red',

                                    onConfirm: () => {

                                    },
                                    onCancel: () => {
                                        Reoverlay.hideModal();

                                    }
                                })
                            }
                        })
                    } else {
                        Reoverlay.showModal(SuccessStageModal, {
                            title: 'موفق',
                            description: message,
                            theme: "green",
                            nextStepText: 'بستن',
                            onConfirm: () => {

                            }
                        });
                        handleInquiryProcess()
                      /*  if (serviceType) {
                            const newDeleted = [...widgetBody.deleted_widgets, serviceType];
                            setwidgetBody({
                                ...widgetBody,
                                deleted_widgets: newDeleted
                            });
                        } else {
                            const newDeleted = [...widgetBody.available_services];
                            setwidgetBody({
                                ...widgetBody,
                                deleted_widgets: newDeleted,
                            })
                        }*/


                        /*  if(!serviceType||([...widgetBody.deleted_widgets,serviceType].length===widgetBody.available_services.length)){
                              setShowWidget(false)
                          }*/
                    }
                }).catch(e => {

                }).finally(() => {
                    setLoading(false);
                })
                Reoverlay.hideModal();
            },
            onBack: () => {
                Reoverlay.hideModal();
            }
        })
    }



    const handleProcess = () => {
        if (serviceContext.pid) {
            serviceContext.handleGetProcess(serviceContext.pid)
        } else {

            serviceContext.handleCreateProcess();
        }
    };


    if (isLoading) {
        return <LoadingScreen/>
    }
    return <div className="mx-auto w-11/12 mt-2   md:w-8/12 lg:w-6/12 ">

        {widgetBody.available_services.length !== widgetBody.deleted_widgets.length && <WidgetBody  handleDeleteWidget={handleDeleteWidget} widget={widgetBody}/>}
        {widgetBody.available_services.length === widgetBody.deleted_widgets.length &&
            <div className="bg-white py-10  mt-5 flex flex-col items-center justify-center px-5  rounded-xl ">
                <h1 className="text-lg text-gray-700 ">{serviceContext.pid ? 'ادامه فرایند احراز هویت' : 'احراز هویت جدید'}</h1>
                <p className="text-center px-2 mb-4 text-sm">{serviceContext.pid ? 'شما یک فرایند احراز هویت ناتمام دارید' : 'با پرداخت مجدد می‌توانید احراز هویت جدید انجام دهید.'}</p>
                <Button onClick={handleProcess} className="text-sm w-full  rounded-lg  "
                        theme="green">{serviceContext.pid ? 'ادامه فرایند جدید' : 'احراز هویت جدید'}</Button>
            </div>}

    </div>

}
const WidgetBody = ({widget, handleDeleteWidget}) => {
    const serviceContext = useContext(AuthenticationServiceContext);
    const handleEditAuth = () => {
        Reoverlay.showModal(EditAuthWidgetModal, {
            widget,
            name: 'تنظیمات افزونه',
            token: serviceContext.token,
            handleInquiryProcess: serviceContext.handleInquiryProcess,
        })
    }
    const showDeleteModal=(widget)=>{

        Reoverlay.showModal(DeleteAuthenticationModal,{
            widget:widget,
            handleDeleteWidget,
        })
    }
    const handleProcess = () => {
        if (serviceContext.pid) {
            serviceContext.handleGetProcess(serviceContext.pid)
        } else {

            serviceContext.handleCreateProcess();
        }
    };
    return <div className="pb-28 ">
        <h1 className="font-bold text-lg  text-center ">مدیریت افزونه</h1>
        <p className="text-center text-sm mb-1 ">
            افزونه شما به صورت زیر روی آگهی قرار دارد.
        </p>
        <div className="bg-white rounded-xl mt-2 p-5  ">
            {widget.widgets_body && !widget.deleted_widgets.includes(AuthenticationDefaultSteps.IAuth) && widget?.available_services.includes(AuthenticationDefaultSteps.IAuth) &&
                <div className="w-full flex justify-start items-center  p-3">
                <div className="widget-image relative">
                    <img
                        src={widget.widgets_body.face_img && (!("pic_visible" in widget.widget_settings )||widget?.widget_settings?.pic_visible) && !widget.deleted_widgets.includes(AuthenticationDefaultSteps.IAuth) ? "data:image/png;base64," + widget.widgets_body.face_img : widget.widgets_body.def_user_img_url}
                        className="w-20 border rounded-lg   h-auto" alt=""/>
                    {widget.widgets_body.face_img && !widget.deleted_widgets.includes(AuthenticationDefaultSteps.IAuth) &&
                        <button onClick={handleEditAuth}
                                className="p-3 bg-white   bg-blue-500   absolute -right-5 rounded-full   flex flex-col items-center justify-center -top-3">
                            <AiFillEdit className="text-xl text-white   "/>
                        </button>}

                </div>
                <div className="mr-3 flex flex-col">

                    <strong>{(!("pic_visible" in widget.widget_settings ) || widget?.widget_settings?.name_visible) ? widget.widgets_body.full_name : 'هویت تایید شده'}</strong>
                    <span className="text-sm ">{widget.widgets_body.person_section_sub_title}</span>
                </div>

            </div>}
            <div className="border-t w-full my-3 "></div>
            {widget.widgets_body && !widget.deleted_widgets.includes(AuthenticationDefaultSteps.POLICE_CLEARANCE) && widget?.available_services.includes(AuthenticationDefaultSteps.POLICE_CLEARANCE) &&
                <div className="w-full flex mb-2 bg-gray-50 flex-col rounded-lg  p-3 ">
                    <div className="justify-start flex items-center">
                        <img src={widget.widgets_body.pi_sub_logo_url} className="w-16 border h-auto" alt=""/>
                        <div className="mr-3 flex flex-col">
                            <strong>{widget.widgets_body.pi_logo_title}</strong>
                            {/*    <span className="text-sm ">{widget.widgets_body.pi_sub_logo_url}</span>*/}
                        </div>
                    </div>
                    <div className="grid border-t mt-2  pt-2 w-full  grid-cols-2">
                        <div className="flex border-l flex-col mt-2 items-center justify-center">
                            <span className="text-sm ">وضعیت</span>
                            <span className="font-bold text-sm mt-2 ">{widget.widgets_body.police_clearance_status}</span>
                        </div>
                        <div className="flex  flex-col mt-2 items-center justify-center">
                            <span className="text-sm ">تاریخ استعلام</span>
                            <span className="font-bold text-sm mt-2 ">{widget.widgets_body.police_clearance_date}</span>
                        </div>
                    </div>
                </div>}
            {widget.widgets_body && !widget.deleted_widgets.includes(AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY) && widget?.available_services.includes(AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY) &&
                <div className="w-full flex  mb-2 mt-2   bg-gray-50 rounded-lg flex-col   p-3 ">
                    <div className="justify-start flex items-center">
                        <img src={widget.widgets_body.bi_sub_logo_url} className="w-16 border h-auto" alt=""/>
                        <div className="mr-3 flex flex-col">
                            <strong>{widget.widgets_body.bi_logo_title}</strong>
                            <span className="text-sm ">{widget.widgets_body.bi_logo_sub_title}</span>
                        </div>
                    </div>
                    <div className="grid border-t mt-2  pt-2 w-full  grid-cols-1">

                        <div className="flex  flex-col mt-2 items-center justify-center">
                            <span className="text-sm ">رسته</span>
                            <span className="font-bold text-sm mt-2 ">{widget.widgets_body.bi_field}</span>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mt-2  border-t ">
                        <div className="flex flex-col border-l mt-2 items-center justify-center">
                            <span className="text-sm ">استان</span>
                            <span className="font-bold text-sm mt-2 ">{widget.widgets_body.bi_state}</span>
                        </div>
                        <div className="flex border-l flex-col mt-2 items-center justify-center">
                            <span className="text-sm ">شهر</span>
                            <span className="font-bold text-sm">{widget.widgets_body.bi_city}</span>
                        </div>

                    </div>


                </div>}
            {widget.widgets_body && !widget.deleted_widgets.includes(AuthenticationDefaultSteps.LAWYER_INQUIRY) && widget?.available_services.includes(AuthenticationDefaultSteps.LAWYER_INQUIRY) &&
                <div className="w-full flex mb-2 bg-gray-50  flex-col rounded-lg  p-3 ">
                    <div className="justify-start flex items-center">
                        <img src={widget.widgets_body.li_sub_logo_url} className="w-16 border h-auto" alt=""/>
                        <div className="mr-3 flex flex-col">
                            <strong>{widget.widgets_body.li_logo_title}</strong>
                            <span className="text-sm ">{widget.widgets_body.li_club}</span>
                        </div>
                    </div>
                    <div className="grid border-t mt-2  pt-2 w-full  grid-cols-2">
                        <div className="flex border-l flex-col mt-2 items-center justify-center">
                            <span className="text-sm ">وضعیت</span>
                            <span className="font-bold text-sm mt-2 ">{widget.widgets_body.li_status}</span>
                        </div>
                        <div className="flex  flex-col mt-2 items-center justify-center">
                            <span className="text-sm ">تاریخ اعتبار</span>
                            <span className="font-bold text-sm mt-2 ">{widget.widgets_body.li_exp_date}</span>
                        </div>
                    </div>


                </div>}
            {widget.widgets_body && !widget.deleted_widgets.includes(AuthenticationDefaultSteps.EXPERT_INQUIRY) && widget?.available_services.includes(AuthenticationDefaultSteps.EXPERT_INQUIRY)  &&
                <div className="w-full flex mb-2 bg-gray-50 flex-col rounded-lg  p-3 ">
                    <div className="justify-start flex items-center">
                        <img src={widget.widgets_body.ei_sub_logo_url} className="w-16 border h-auto" alt=""/>
                        <div className="mr-3 flex flex-col">
                            <strong>{widget.widgets_body.ei_logo_title}</strong>
                            <span className="text-sm ">{widget.widgets_body.ei_club}</span>
                        </div>
                    </div>
                    <div className="grid border-t mt-2  pt-2 w-full  grid-cols-2">
                        <div className="flex border-l flex-col mt-2 items-center justify-center">
                            <span className="text-sm ">وضعیت</span>
                            <span className="font-bold text-sm mt-2 ">{widget.widgets_body.ei_status}</span>
                        </div>
                        <div className="flex  flex-col mt-2 items-center justify-center">
                            <span className="text-sm ">تاریخ اعتبار</span>
                            <span className="font-bold text-sm mt-2 ">{widget.widgets_body.ei_exp_date}</span>
                        </div>
                    </div>

                </div>}


            <BottomButtonWrapper grid={2}>
                <button onClick={() => {

                    showDeleteModal(widget)
                }}
                        className="border w-full text-sm  py-2 rounded-lg   border-red-400 text-red-400 ">حذف  افزونه
                </button>
                <Button onClick={handleProcess} className="text-sm w-full  rounded-lg  "
                        theme="green">{serviceContext.pid ? 'ادامه فرایند جدید' : 'احراز هویت جدید'}</Button>
            </BottomButtonWrapper>
        </div>
    </div>
}
export default Widget;